import React, { createContext, ReactNode,useContext, useState } from "react";

interface IntegrationContextType {
  credentials: any;
  setCredentials: (credentials: any) => void;
}

const IntegrationContext = createContext<IntegrationContextType | null>(null);

export function IntegrationProvider({ children }: { children: ReactNode }) {
  const [credentials, setCredentials] = useState<any>({});

  return (
    <IntegrationContext.Provider value={{ credentials, setCredentials }}>
      {children}
    </IntegrationContext.Provider>
  );
}

export function useIntegrationContext() {
  const context = useContext(IntegrationContext);
  if (!context) {
    throw new Error("useIntegrationContext must be used within an IntegrationProvider");
  }
  return context;
}